import React, { useState } from "react";
import logo from "../../Assets/Images/logo.png";
import { Link, NavLink } from "react-router-dom";
import { useGlobalContext } from "../../Context/GlobalContext";
import { FaTasks } from "react-icons/fa";
import { AiOutlineHome } from "react-icons/ai";
import { FaFileInvoice } from "react-icons/fa";
import { GrDocumentNotes } from "react-icons/gr";
import { GoProjectRoadmap } from "react-icons/go";
import { IoChatboxEllipsesOutline } from "react-icons/io5";

const SidebarStaff = () => {
  const { selectedSidebarTab, setSelectedSidebarTab } = useGlobalContext();

  const handleLinkClick = (tab) => {
    // Set the selected sidebar tab
    setSelectedSidebarTab(tab);
    // Close sidebar on small screens
    if (window.innerWidth < 850) {
      // Remove the custom class
      document.body.classList.remove("custom-body-class");
    }
  };

  return (
    <div className="lg:top-[0px] flex-shrink-0 content-container bg-[#27004a] p-[5px] sm:p-[10px] pb-[57px] w-full sm:w-[340px] md:w-[270px] h-[100vh] overflow-y-scroll selection sidebar">
      <div className="flex lg:justify-center xl:justify-center p-[20px]">
        <img src={logo} alt="" className="w-[120px]" />
      </div>
      <ul className="pt-[0px] pr-[2px] pb-[20px] pl-[2px]">
        <NavLink
          to="/s"
          onClick={() => {
            handleLinkClick("dashboard");
          }}
          className={`flex items-center gap-[10px] group hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px] rounded-md transition-all ${selectedSidebarTab === "dashboard"
              ? "bg-white text-[#8a25b0]"
              : "text-white"
            }`}
        >
          <AiOutlineHome className="group-hover:text-[#8a25b0] text-xl" />
          <button className="group-hover:text-[#8a25b0]">Dashboard</button>
        </NavLink>
        <NavLink
          to="/s/chats"
          onClick={() => {
            handleLinkClick("chat");
          }}
          className={`flex items-center gap-[10px] hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px]   rounded-md  transition-all ${selectedSidebarTab === "chat"
              ? "bg-white text-[#8a25b0]"
              : "text-white"
            }`}
        >
          <IoChatboxEllipsesOutline className="group-hover:text-[#8a25b0] text-xl" />
          <button className="">Chat</button>
        </NavLink>

        <NavLink
          to="/s/projects"
          onClick={() => {
            handleLinkClick("projects");
          }}
          className={`flex items-center gap-[10px] hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px]   rounded-md  transition-all ${selectedSidebarTab === "projects"
              ? "bg-white text-[#8a25b0]"
              : "text-white"
            }`}
        >
          <GoProjectRoadmap className="group-hover:text-[#8a25b0] text-xl" />
          <button>Projects</button>
        </NavLink>

        <NavLink
          to="/s/task"
          onClick={() => {
            handleLinkClick("task");
          }}
          className={`flex items-center gap-[10px] hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px]   rounded-md  transition-all ${selectedSidebarTab === "task"
              ? "bg-white text-[#8a25b0]"
              : "text-white"
            }`}
        >
          <FaTasks className="group-hover:text-[#8a25b0] text-xl" />
          <button>Task</button>
        </NavLink>


      </ul>
    </div>
  );
};

export default SidebarStaff;
